import React, { useState, useEffect } from "react";
import { TContentHubSeriesDetailsProps } from "../types/ContentHubSeriesDetails.type";
import LazySection from "../../../react-only-components/LazySection";
import ExperienceEditorComponentPlaceholder from "../../../react-only-components/ExperienceEditorComponentPlaceholder";
import ComponentDetails from "./ComponentDetails";
import { SeriesDetailsModel } from "../models/ContentHubSeriesDetails.model";

const ContentHubSeriesDetails = (props: TContentHubSeriesDetailsProps) => {
  const isEEActive = props?.sitecoreContext?.pageEditing;
  const isPreview = props?.sitecoreContext?.pageState === "preview";
  const isPlaceholderShown = isEEActive || isPreview;
  const model = new SeriesDetailsModel(props);

  const [collapsedTabs, setCollapsedTabs] = useState(
    model.innerComponents?.map(({ id }) => id)
  );

  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);

  const toggleTab = (tabId: number) => {
    if (collapsedTabs.includes(tabId)) {
      setCollapsedTabs(collapsedTabs.filter((tab) => tab !== tabId));
    } else {
      setCollapsedTabs([...collapsedTabs, tabId]);
    }
  };

  return (
    <LazySection>
      {isPlaceholderShown ? (
        <ExperienceEditorComponentPlaceholder text="Content Hub Series Details - Component Placeholder" />
      ) : (
        <section
          className="series-details"
          id={props?.fields?.apiData?.id?.toString()}
        >
          <div className="series-details__container">
            <div className="series-details__header">
              {model?.eyebrow && (
                <p className="series-details__eyebrow">{model.eyebrow}</p>
              )}
              {model?.title && (
                <h1 className="series-details__title">{model.title}</h1>
              )}
              {model?.description && (
                <p className="series-details__description">
                  {model.description}
                </p>
              )}
            </div>
            <ul className="series-details__tabs">
              {model?.innerComponents?.map((component, index) => {
                const isCollapsed = collapsedTabs.includes(component.id);
                return (
                  <li className="series-details__tab" key={index}>
                    <button
                      className="series-details__tab-button"
                      onClick={() => {
                        toggleTab(component.id);
                      }}
                    >
                      {component.eyebrow}
                      <pfe-icon
                        size="24"
                        icon={
                          isCollapsed
                            ? "dcx-arrow-i-os-downward"
                            : "dcx-arrow-i-os-upward"
                        }
                      />
                    </button>
                    <ComponentDetails
                      component={model.innerComponents[index]}
                      className={`${
                        isCollapsed ? "series-details__component--hidden" : ""
                      }`}
                    />
                  </li>
                );
              })}
            </ul>
          </div>
        </section>
      )}
    </LazySection>
  );
};

export default ContentHubSeriesDetails;
